import { Component, Input } from '@angular/core';
import { CalculationKeynameEnum } from '../../../../../../../../common/src/enums/calculations/calculation-keyname.enum';
import { TimelineEventModel } from '../timeline-event.model';
import { CalculationsUtils } from '../../../../../../modules/src/lib/calculations/utils/calculations.utils';

@Component({
  selector: 'app-timeline-calculation-run-event',
  templateUrl: './timeline-calculation-run-event.component.html',
  styleUrls: ['./timeline-calculation-run-event.component.scss'],
  standalone: false,
})
export class TimelineCalculationRunEventComponent {

  @Input()
  public event: TimelineEventModel;

  constructor(
    private readonly calculationsUtils: CalculationsUtils,
  ) {
  }

  getKeynameText(calculationKeyname: CalculationKeynameEnum): string {
    return this.calculationsUtils.getCalculationKeynameText(calculationKeyname);
  }
}
